import Vue from 'vue'

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
const files = require.context('./../components/', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default) )

Vue.prototype.lang = ( string ) => ( window.translations[string] ? window.translations[string] : string );

export default class VueManager {

    constructor() {
        this.app = false
    }

    create() {
        if( document.querySelector('main.main-content').classList.contains('enable-vue') ) {
            this.app = new Vue({
                el: '#app'
            });
            document.querySelector('main.main-content').classList.remove('enable-vue');
            document.querySelector('main.main-content').classList.add('vue-enabled');
        }
    }

    destroy() {
        if( document.querySelector('main.main-content').classList.contains('vue-enabled') ) {
            this.app.$destroy();
        }
    }

}